import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export var ProgressTrackerContainer = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n\n  && {\n    margin-top: 40px;\n  }\n\n  list-style-type: none;\n  padding: 0px;\n"])));
export default ProgressTrackerContainer;